export const navigationWarningsTranslations = {
  en: {
    pageTitle: 'Navigation Warnings',
    loading: 'Loading Warnings...',
    noWarningsMemory: 'No navigation warning information in memory - restart the app and try again',
    warningsError: 'Problem receiving navigation warning data - restart the app and try again',
    errorHeader: 'Data retrieval error',
    errorMessage: 'There was a problem retrieving the dock data! Please restart the app and try again.',
    okButton: 'Ok',
    warningDate: 'Warning date:',
    notificationDate: 'Notification date:',
    dangerZoneBadge: 'Danger zone',
    dangerZonePublication: 'Published:',
    showOnMap: 'Show on map',
    pullToRefresh: 'Pull to refresh',
    noItems: 'No items to display.'
  },
  it: {
    pageTitle: 'Avvisi di cauta navigazione',
    loading: 'Caricamento Avvisi...',
    noWarningsMemory: 'Non sono presenti informazioni sugli avvisi di cauta navigazione in memoria - riavviare l\'app e riprovare',
    warningsError: 'Problema nella ricezione dei dati sugli avvisi di cauta navigazione - riavviare l\'app e riprovare',
    errorHeader: 'Errore di recupero dati',
    errorMessage: 'C\'è stato un problema nel recupero dei dati sugli attracchi! Per favore riavvia l\'app e riprova.',
    okButton: 'Ok',
    warningDate: 'Data avviso:',
    notificationDate: 'Data notifica:',
    dangerZoneBadge: 'Zona di pericolo',
    dangerZonePublication: 'Pubblicazione:',
    showOnMap: 'Mostra sulla mappa',
    pullToRefresh: 'Trascina per aggiornare',
    noItems: 'Nessun elemento da mostrare.'
  }
}; 